import { createSlice } from "@reduxjs/toolkit";

const candidatesSlice = createSlice({
  name: "candidates",
  initialState: {
    status: "idle",
    error: null,
    loading: false,
    candidate_list: [],
    filteredCandidates: [],
    // Persistent filter state
    filters: {
      searchTerm: '',
      selectedCompanies: [],
      selectedInstitutions: [],
      selectedSkills: [],
      selectedLocations: [],
      selectedScreeningStatus: [],
      experienceRange: [0, 50],
      salaryRange: [0, 200000],
      educationLevel: [],
      dateRange: [null, null],
      matchScoreRange: [0, 100],
      selectedRating: []
    },
    // Additional state for existing components
    forwardedCandidates: [],
    forwardingLoading: false
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },    
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    loadCandidateData(state, action) {
      state.candidate_list = action.payload;
    },
    setFilteredCandidates: (state, action) => {
      state.filteredCandidates = action.payload;
    },
    // Additional reducers for existing components
    setForwardedCandidates: (state, action) => {
      state.forwardedCandidates = action.payload;
    },
    setForwardingLoading: (state, action) => {
      state.forwardingLoading = action.payload;
    },
    // Filter state reducers
    setSearchTerm: (state, action) => {
      state.filters.searchTerm = action.payload;
    },
    setSelectedCompanies: (state, action) => {
      state.filters.selectedCompanies = Array.isArray(action.payload) ? action.payload : [];
    },
    setSelectedInstitutions: (state, action) => {
      state.filters.selectedInstitutions = Array.isArray(action.payload) ? action.payload : [];
    },
    setSelectedSkills: (state, action) => {
      state.filters.selectedSkills = Array.isArray(action.payload) ? action.payload : [];
    },
    setSelectedLocations: (state, action) => {
      state.filters.selectedLocations = Array.isArray(action.payload) ? action.payload : [];
    },
    setSelectedScreeningStatus: (state, action) => {
      state.filters.selectedScreeningStatus = Array.isArray(action.payload) ? action.payload : [];
    },
    setExperienceRange: (state, action) => {
      state.filters.experienceRange = action.payload;
    },
    setSalaryRange: (state, action) => {
      state.filters.salaryRange = action.payload;
    },
    setEducationLevel: (state, action) => {
      state.filters.educationLevel = Array.isArray(action.payload) ? action.payload : [];
    },
    setDateRange: (state, action) => {
      state.filters.dateRange = action.payload;
    },
    setMatchScoreRange: (state, action) => {
      state.filters.matchScoreRange = action.payload;
    },
    setSelectedRating: (state, action) => {
      state.filters.selectedRating = Array.isArray(action.payload) ? action.payload : [];
    },
    clearAllFilters: (state) => {
      state.filters = {
        searchTerm: '',
        selectedCompanies: [],
        selectedInstitutions: [],
        selectedSkills: [],
        selectedLocations: [],
        selectedScreeningStatus: [],
        experienceRange: [0, 50],
        salaryRange: [0, 200000],
        educationLevel: [],
        dateRange: [null, null],
        matchScoreRange: [0, 100],
        selectedRating: []
      };
    },
  },
});

export const {
  setError,
  setLoading,
  loadCandidateData,
  setFilteredCandidates,
  setForwardedCandidates,
  setForwardingLoading,
  // Filter actions
  setSearchTerm,
  setSelectedCompanies,
  setSelectedInstitutions,
  setSelectedSkills,
  setSelectedLocations,
  setSelectedScreeningStatus,
  setExperienceRange,
  setSalaryRange,
  setEducationLevel,
  setDateRange,
  setMatchScoreRange,
  setSelectedRating,
  clearAllFilters
} = candidatesSlice.actions;

// Selectors for existing components
export const selectCandidates = (state) => state.candidates.candidate_list;
export const selectFilteredCandidates = (state) => state.candidates.filteredCandidates;
export const selectLoading = (state) => state.candidates.loading;
export const selectForwardedCandidates = (state) => state.candidates.forwardedCandidates;
export const selectForwardingLoading = (state) => state.candidates.forwardingLoading;

// Filter selectors
export const selectFilters = (state) => state.candidates.filters;
export const selectSearchTerm = (state) => state.candidates.filters.searchTerm;
export const selectSelectedCompanies = (state) => state.candidates.filters.selectedCompanies || [];
export const selectSelectedInstitutions = (state) => state.candidates.filters.selectedInstitutions || [];
export const selectSelectedSkills = (state) => state.candidates.filters.selectedSkills || [];
export const selectSelectedLocations = (state) => state.candidates.filters.selectedLocations || [];
export const selectSelectedScreeningStatus = (state) => state.candidates.filters.selectedScreeningStatus || [];
export const selectExperienceRange = (state) => state.candidates.filters.experienceRange;
export const selectSalaryRange = (state) => state.candidates.filters.salaryRange;
export const selectEducationLevel = (state) => state.candidates.filters.educationLevel || [];
export const selectDateRange = (state) => state.candidates.filters.dateRange;
export const selectMatchScoreRange = (state) => state.candidates.filters.matchScoreRange;
export const selectSelectedRating = (state) => state.candidates.filters.selectedRating || [];

export default candidatesSlice.reducer; 